import styled from '@emotion/styled';
import { Modal } from '@lightspeed/flame/Modal';
import { Text } from '@lightspeed/flame/Text';

export const StyledModal = styled(Modal)`
  max-width: 600px;
  width: 600px;
`;

export const StyledHeaderText = styled(Text)`
  font-size: 1rem;
`;

export const StyledBodyText = styled(Text)`
  font-size: 0.875rem;
`;
